import Page from ".";

export const pageRoutes = (data) => [
  {
    path: "/admin/page",
    title: "Page",
    layout: "admin",
    routeType: "admin",
    component: Page,
  },
];
